import React from 'react';
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

/**
 * 勾选清单（☑ ≡）线性图标：@ant-design/icons 没有同款，按 Antd 自定义图标方式实现，尺寸 / 颜色随菜单继承。
 * viewBox 从 24 收紧到 22（裁掉四周 1 单位留白），图形放大约 9%，与菜单内 Antd 图标视觉大小接近；占位仍为 1em，不影响对齐
 */
const ListChecksSvg = () => (
    <svg
        viewBox="1 1 22 22"
        width="1em"
        height="1em"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="m3 7 2 2 4-4" />
        <path d="m3 17 2 2 4-4" />
        <path d="M13 6h8" />
        <path d="M13 12h8" />
        <path d="M13 18h8" />
    </svg>
);

const ListChecksOutlined: React.FC<Partial<CustomIconComponentProps>> = (props) => <Icon component={ListChecksSvg} {...props} />;

export default ListChecksOutlined;
